import React from 'react';
import {
  CANAL_LABELS,
  ETAPA_COPILOTO_LABELS,
  FORMA_PAGO_COPILOTO_LABELS,
  labelFromCatalog,
  PRIORIDAD_LABELS,
  PROXIMA_ACCION_LABELS,
  TEMPERATURA_COPILOTO_LABELS,
} from '../../../services/copilotoComercialService';

export default function HistorialCopiloto({
  historial,
  cargando = false,
  error = '',
  onRetry,
  onLoadMore,
}) {
  const items = historial?.items || [];
  const puedeCargarMas = Number(historial?.pagina || 1) < Number(historial?.totalPaginas || 1);

  return (
    <section className="crm-prospectos-card copiloto-card">
      <div className="crm-prospectos-section-head">
        <h2>Historial del Copiloto</h2>
        {puedeCargarMas ? <button type="button" onClick={onLoadMore} disabled={cargando}>Cargar mas</button> : null}
      </div>
      {cargando ? <p className="crm-prospectos-feedback">Cargando historial...</p> : null}
      {error ? (
        <p className="crm-prospectos-feedback is-error">
          <span>{error}</span>
          <button type="button" onClick={onRetry}>Reintentar</button>
        </p>
      ) : null}
      {!cargando && !error && items.length === 0 ? <p className="crm-prospectos-empty">Sin interacciones registradas.</p> : null}
      <div className="copiloto-historial-list">
        {items.map((item) => (
          <article key={item.id || `${item.fecha}-${item.resumen}`}>
            <div className="copiloto-historial-head">
              <strong>{item.fecha}</strong>
              <span>{labelFromCatalog(CANAL_LABELS, item.canal)}</span>
            </div>
            <div className="copiloto-chip-list">
              {item.etapaComercial ? <span>{labelFromCatalog(ETAPA_COPILOTO_LABELS, item.etapaComercial)}</span> : null}
              {item.temperatura ? <span>{labelFromCatalog(TEMPERATURA_COPILOTO_LABELS, item.temperatura)}</span> : null}
              {item.formaPago ? <span>{labelFromCatalog(FORMA_PAGO_COPILOTO_LABELS, item.formaPago)}</span> : null}
            </div>
            <p>{item.resumen || 'Sin resumen'}</p>
            {item.proximaAccionTipo ? (
              <small>
                Proxima accion: {labelFromCatalog(PROXIMA_ACCION_LABELS, item.proximaAccionTipo)}
                {item.proximaAccionFecha ? ` · ${item.proximaAccionFecha}` : ''}
                {item.proximaAccionPrioridad ? ` · ${labelFromCatalog(PRIORIDAD_LABELS, item.proximaAccionPrioridad)}` : ''}
              </small>
            ) : null}
            {item.respuestaEnviada ? <blockquote>{item.respuestaEnviada}</blockquote> : null}
            {item.etiquetas.length ? (
              <div className="copiloto-chip-list">
                {item.etiquetas.map((tag) => <span key={tag}>{tag}</span>)}
              </div>
            ) : null}
            {item.responsable ? <small>Responsable: {item.responsable}</small> : null}
          </article>
        ))}
      </div>
    </section>
  );
}
